
export default function DirectorSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            院長挨拶
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="flex justify-center">
            <img 
              src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/56cbd252332703f206afee0056c93662.jpeg"
              alt="院長 田中 健一"
              className="w-full max-w-md h-[500px] rounded-lg shadow-lg object-cover object-top"
            />
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              院長 田中 健一
            </h3>
            
            <div className="space-y-6">
              <div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3">ご挨拶</h4>
                <p className="text-gray-600 leading-relaxed">
                  この度は、当院のホームページをご覧いただき、誠にありがとうございます。私は院長の田中健一と申します。
                </p>
                <p className="text-gray-600 leading-relaxed mt-4">
                  当院では、患者様一人ひとりの症状に真摯に向き合い、最適な治療を提供することを心がけております。豊富な経験と最新の技術を駆使し、皆様の健康回復と維持をサポートいたします。
                </p>
                <p className="text-gray-600 leading-relaxed mt-4">
                  お身体の不調でお悩みの方は、どうぞお気軽にご相談ください。スタッフ一同、心よりお待ちしております。
                </p>
              </div>

              <div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3">経歴・資格</h4>
                <div className="space-y-2 text-gray-600">
                  <div className="flex items-start">
                    <i className="ri-graduation-cap-line text-[#3cb371] mr-3 mt-1"></i>
                    <span>日本柔道整復師専門学校 卒業</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-award-line text-[#3cb371] mr-3 mt-1"></i>
                    <span>柔道整復師免許取得（平成8年）</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-hospital-line text-[#3cb371] mr-3 mt-1"></i>
                    <span>都内整骨院にて10年間勤務</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-building-line text-[#3cb371] mr-3 mt-1"></i>
                    <span>平成18年 当院開院</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-medal-line text-[#3cb371] mr-3 mt-1"></i>
                    <span>日本柔道整復師会 正会員</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-book-line text-[#3cb371] mr-3 mt-1"></i>
                    <span>スポーツ外傷・障害予防指導員</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
